(() => {
  const formSelector = 'form[data-nc-ajax-cart]';

  const showError = (form, message = '') => {
    let error = form.querySelector('[data-nc-cart-error]');

    if (!error && message) {
      error = document.createElement('p');
      error.dataset.ncCartError = '';
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }

    if (error) {
      error.textContent = message;
      error.hidden = !message;
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest(formSelector);
    if (!form) return;

    event.preventDefault();

    const submitButton = form.querySelector('[type="submit"]');
    if (!submitButton || submitButton.getAttribute('aria-disabled') === 'true') return;

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const formData = new FormData(form);
    const originalButtonText = submitButton.textContent;

    showError(form);
    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.disabled = true;
    submitButton.textContent = 'Wird hinzugefügt …';

    if (cart) {
      formData.append(
        'sections',
        cart
          .getSectionsToRender()
          .map((section) => section.id)
          .join(',')
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    try {
      const response = await fetch(window.routes.cart_add_url, config);
      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Das Produkt konnte nicht hinzugefügt werden.');
      }

      if (cart) {
        cart.classList.remove('is-empty');
        cart.renderContents(result);
      }
    } catch (error) {
      console.error(error);
      showError(form, error.message);
    } finally {
      submitButton.removeAttribute('aria-disabled');
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
    }
  });
})();
